import type { WindowedCursorListRange } from '../../../hooks/useWindowedCursorList'
import type { ISocialOrderListItem } from '../../../api/types/socialOrders'
import { VirtualCursorList } from '../../ui-kit/VirtualCursorList'
import { SocialOrderItem } from '../SocialOrderItem'

interface SocialOrdersListProps {
  socialOrders: ISocialOrderListItem[]
  firstItemIndex?: number
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
  onStartReached?: () => void
  onRangeChanged?: (range: WindowedCursorListRange) => void
  emptyMessage?: string
}

export const SocialOrdersList = ({
  socialOrders,
  firstItemIndex,
  hasMore,
  isLoadingMore,
  onLoadMore,
  onStartReached,
  onRangeChanged,
  emptyMessage = 'Нет социальных заказов для отображения',
}: SocialOrdersListProps) => {
  return (
    <VirtualCursorList
      items={socialOrders}
      firstItemIndex={firstItemIndex}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={onLoadMore}
      onStartReached={onStartReached}
      onRangeChanged={onRangeChanged}
      getItemKey={(_index, socialOrder) => socialOrder.id}
      emptyMessage={emptyMessage}
      itemContent={(_index, socialOrder) => <SocialOrderItem socialOrder={socialOrder} />}
    />
  )
}
